"use strict";
// Mean test date per timepoint ("T1 (Ø 03/2026)") for the group charts, the
// compact school table and the dashboard PDF. See documentation/charts.md.
Object.defineProperty(exports, "__esModule", { value: true });
exports.timepointMeanLabel = exports.formatDateDe = exports.formatMonthYear = void 0;
exports.meanIsoDate = meanIsoDate;
exports.pooledMeanDate = pooledMeanDate;
const MS_PER_DAY = 24 * 60 * 60 * 1000;
const dayNumber = (isoDate) => Math.round(Date.parse(`${isoDate.slice(0, 10)}T00:00:00Z`) / MS_PER_DAY);
const isoFromDay = (day) => new Date(day * MS_PER_DAY).toISOString().slice(0, 10);
/** Arithmetic mean of YYYY-MM-DD dates, rounded to a whole day; null for none. */
function meanIsoDate(dates) {
    if (dates.length === 0)
        return null;
    const sum = dates.reduce((s, d) => s + dayNumber(d), 0);
    return isoFromDay(Math.round(sum / dates.length));
}
/**
 * Mean date over several groups (e.g. all schools at T1), weighted by the
 * number of children behind each group mean. Same result as the mean over
 * all children (up to the rounding of each group to whole days).
 */
function pooledMeanDate(groups) {
    let sum = 0;
    let total = 0;
    for (const g of groups) {
        if (!g.dateMean || g.n <= 0)
            continue;
        sum += dayNumber(g.dateMean) * g.n;
        total += g.n;
    }
    return total ? isoFromDay(Math.round(sum / total)) : null;
}
/** "2026-03-14" -> "03/2026" (compact mean date in legends and axes). */
const formatMonthYear = (isoDate) => isoDate ? `${isoDate.slice(5, 7)}/${isoDate.slice(0, 4)}` : "";
exports.formatMonthYear = formatMonthYear;
/** "2026-03-14" -> "14.03.2026". */
const formatDateDe = (isoDate) => isoDate
    ? `${isoDate.slice(8, 10)}.${isoDate.slice(5, 7)}.${isoDate.slice(0, 4)}`
    : "";
exports.formatDateDe = formatDateDe;
/** "T1 (Ø 03/2026)", or just "T1" without a date. */
const timepointMeanLabel = (key, dateMean) => (dateMean ? `${key} (Ø ${(0, exports.formatMonthYear)(dateMean)})` : key);
exports.timepointMeanLabel = timepointMeanLabel;
